<template>
  <div>
    <!-- ************************************** Paso 1 ******************************************* -->
    <section v-if="step == 1">
      <div class="step-grid mb-5">
        <div class="step-icon-border first-load-border mr-5">
          <b-icon-list-ul
            id="step1"
            class="step-icon first-load-icon"
          ></b-icon-list-ul>
          <p class="step-caption text-success">
            {{
              $t("section.sectionView.step1Details", {
                entity: $getVisibleNames("teaching.section", false, "Sección"),
              })
            }}
          </p>
        </div>
        <div class="step-icon-border mx-5">
          <b-icon-people-fill class="step-icon"></b-icon-people-fill>
          <p class="step-caption">
            {{ $t("section.sectionView.step2AssignStudents") }}
          </p>
        </div>
        <div class="step-icon-border ml-5">
          <b-icon-person-check-fill
            class="step-icon"
          ></b-icon-person-check-fill>
          <p class="step-caption">
            {{ $t("section.sectionView.step3AssignTeachers") }}
          </p>
        </div>
      </div>
      <span class="progress first-load"></span>
      <div class="container-group">
        <div class="group">
          <b-form-group
            :label="$t('reusable.common.name')"
            label-for="input-name"
            label-cols="3"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-input
              id="input-name"
              v-model="$v.section.name.$model"
              :state="validateState('name')"
              :disabled="!allows_crud"
              aria-describedby="input-name-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-name-feedback">
              <span v-if="section.name.trim() == ''">
                {{ $t("reusable.common.required") }}.
              </span>
              <span v-else>
                {{ $t("section.sectionView.sectionAlreadyExists") }}
              </span>
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <!-- ******************************** SE COMENTA SELECTOR COLOR EN SECCIONES ************************************** -->
        <!-- <div class="group">
        <b-form-group
          label="Color"
          label-for="input-color"
          label-cols="4"
          label-cols-sm="3"
          class="m-0"
        >
          <b-form-input
            id="input-color"
            v-model="$v.section.color.$model"
            :state="validateState('color')"
            :disabled="!allows_crud"
            aria-describedby="input-color-feedback"
            size="sm"
            type="color"
          ></b-form-input>
          <b-form-invalid-feedback id="input-color-feedback"
            >Este campo es obligatorio.</b-form-invalid-feedback
          >
        </b-form-group>
        </div> -->
        <!-- <div class="group">
          <b-form-group
            v-if="egressProfile"
            label="Nivel"
            label-for="select-level"
            label-cols="4"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-select
              id="select-level"
              :options="levels"
              v-model="$v.section.plan_level.$model"
              :state="validateState('plan_level')"
              :disabled="!allows_crud || !edit_level"
              aria-describedby="select-level-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-level-feedback"
              >Este campo es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>
        </div> -->
        <div v-if="egressProfile" class="group">
          <b-form-group
            :label="
              $getVisibleNames('mesh.egressprofilematter', false, 'Asignatura')
            "
            label-for="select-egress_profile_matter"
            label-cols="3"
            label-cols-sm="3"
            class="mb-1 mr-0 ml-0"
          >
            <v-select
              id="select-egress_profile_matter"
              v-model="$v.section.egress_profile_matter.$model"
              :options="matterList"
              :reduce="(matterList) => matterList.id"
              :state="validateState('egress_profile_matter')"
              :disabled="!allows_crud || !edit_matter"
              :placeholder="
                $t('section.sectionView.selectEntity', {
                  entity: $getVisibleNames(
                    'teaching.matter',
                    false,
                    'Asignatura'
                  ).toLowerCase(),
                })
              "
              @input="changeEgressProfileMatter"
              aria-describedby="select-egress_profile_matter-feedback"
              size="md"
              label="label"
              track-by="id"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("section.sectionView.noSearchResults") }}
                  <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.label }}
              </template>
            </v-select>
            <div
              class="div-invalid-feedback"
              v-if="$v.section.egress_profile_matter.$anyError == true"
            >
              <div v-if="section.egress_profile_matter == null">
                {{ $t("reusable.common.required") }}.
              </div>
              <div
                v-if="
                  matter &&
                  matter.matter != null &&
                  theTestsHaveSomeErrors &&
                  isNaN(section.id)
                "
              >
                {{
                  $t(
                    "section.sectionView.cannotCreateSectionEvaluationErrors",
                    {
                      section: $getVisibleNames(
                        "teaching.section",
                        false,
                        "Sección"
                      ),
                      subject: $getVisibleNames(
                        "mesh.egressprofilematter",
                        false,
                        "Asignatura"
                      ),
                    }
                  )
                }}
                <div>
                  {{ $t("section.sectionView.forMoreInfo") }}
                  <span
                    class="link-modal-evaluations"
                    @click="$bvModal.show(`new-evaluation-list-modal`)"
                    >{{ $t("section.sectionView.seeMore") }}</span
                  >.
                </div>
              </div>
            </div>
          </b-form-group>
        </div>
        <div v-if="!egressProfile" class="group">
          <b-form-group
            :label="$getVisibleNames('teaching.matter', false, 'Asignatura')"
            label-for="select-level"
            label-cols="3"
            label-cols-sm="3"
            class="mb-1 mr-0 ml-0"
          >
            <!-- :class="{ 'diable-search': section.matter != null }" -->
            <v-select
              v-model="$v.section.matter.$model"
              :options="sortMatters"
              :reduce="(sortMatters) => sortMatters.id"
              :state="validateState('matter')"
              :disabled="!allows_crud || !edit_matter"
              :placeholder="
                $t('section.sectionView.selectEntityWithDashes', {
                  entity: $getVisibleNames(
                    'teaching.matter',
                    false,
                    'Asignatura'
                  ).toLowerCase(),
                })
              "
              label="label"
              track-by="id"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("section.sectionView.noSearchResults") }}
                  <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.label }}
              </template>
            </v-select>
            <div
              class="div-invalid-feedback"
              v-if="$v.section.matter.$anyError == true"
            >
              {{ $t("reusable.common.required") }}.
            </div>
          </b-form-group>
        </div>
        <div class="group" v-if="!egressProfile">
          <b-form-group
            :label="$getVisibleNames('mesh.periodtype', false, 'Régimen')"
            label-for="select-period_type"
            label-cols="3"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-select
              id="select-period_type"
              :options="regimes"
              value-field="id"
              text-field="name"
              v-model="period_type_id"
              :disabled="!allows_crud || !edit_period"
              aria-describedby="select-period_type-feedback"
              @change="() => (section.period = null)"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-period_type-feedback"
              >{{ $t("reusable.common.required") }}.</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
        <!-- Jornada -->
        <div class="group">
          <b-form-group
            :label="$getVisibleNames('mesh.shift', false, 'Jornada')"
            label-for="select-shift"
            label-cols="3"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-select
              id="select-shift"
              :options="shifts"
              value-field="id"
              text-field="name"
              v-model="$v.section.shift.$model"
              :state="validateState('shift')"
              :disabled="!allows_crud || !edit_shift"
              aria-describedby="select-shift-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-shift-feedback"
              >{{ $t("reusable.common.required") }}.</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
        <!-- Sede -->
        <div class="group">
          <b-form-group
            :label="$getVisibleNames('mesh.campus', false, 'Sede')"
            label-for="select-campus"
            label-cols="3"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-select
              id="select-campus"
              :options="filteredCampuses"
              value-field="id"
              text-field="name"
              v-model="$v.section.campus.$model"
              :state="validateState('campus')"
              :disabled="!allows_crud || !edit_campus"
              aria-describedby="select-campus-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-campus-feedback"
              >{{ $t("reusable.common.required") }}.</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
        <!-- Periodo -->
        <div class="group">
          <b-form-group
            :label="$getVisibleNames('mesh.period', false, 'Período')"
            label-for="select-period"
            label-cols="3"
            label-cols-sm="3"
            class="m-0"
          >
            <b-form-select
              id="select-period"
              :options="periodList"
              value-field="id"
              text-field="label"
              v-model="$v.section.period.$model"
              :state="validateState('period')"
              :disabled="!allows_crud || !edit_period || periodList.length == 0"
              aria-describedby="select-period-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-period-feedback"
              >{{ $t("reusable.common.required") }}.</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
      </div>
    </section>
    <!-- ************************************** Paso 2 ******************************************* -->
    <div class="hidden-step" :class="{ 'is-shown': this.step == 2 }">
      <div class="step-grid mb-5">
        <div class="step-icon-border second-load-border-step1 mr-5 done">
          <b-icon-list-ul
            id="step1"
            class="step-icon second-load-icon-step1"
            variant="success"
          ></b-icon-list-ul>
          <p class="step-caption text-success">
            {{
              $t("section.sectionView.step1Details", {
                entity: $getVisibleNames("teaching.section", false, "Sección"),
              })
            }}
            <b-icon-check2-circle variant="success"></b-icon-check2-circle>
          </p>
        </div>
        <div class="step-icon-border second-load-border mx-5">
          <b-icon-people-fill
            class="step-icon second-load-icon"
          ></b-icon-people-fill>
          <p class="step-caption text-success">
            {{ $t("section.sectionView.step2AssignStudents") }}
          </p>
        </div>
        <div class="step-icon-border ml-5">
          <b-icon-person-check-fill
            class="step-icon"
          ></b-icon-person-check-fill>
          <p class="step-caption">
            {{ $t("section.sectionView.step3AssignTeachers") }}
          </p>
        </div>
      </div>
      <div class="progress second-load"></div>
      <div>
        <h5 class="ml-3">{{ $t("section.sectionView.students") }}</h5>
        <UserListSection
          v-if="step == 2"
          :key_component="'evaluatee:'"
          :users_ids="[].concat(section.students)"
          :section_id="section.id"
          :allows_crud="allows_crud"
          @changed="slotStudentsChanged"
          :required_group_name="'ESTUDIANTES'"
          :filter_by_student="true"
        ></UserListSection>
      </div>
    </div>
    <!-- ************************************** Paso 3 ******************************************* -->
    <div class="hidden-step" :class="{ 'is-shown': this.step == 3 }">
      <div class="step-grid mb-5">
        <div class="step-icon-border third-load-border-step1 mr-5 done">
          <b-icon-list-ul
            id="step1"
            class="step-icon third-load-icon-step1"
            variant="success"
          ></b-icon-list-ul>
          <p class="step-caption text-success">
            {{
              $t("section.sectionView.step1Details", {
                entity: $getVisibleNames("teaching.section", false, "Sección"),
              })
            }}
            <b-icon-check2-circle variant="success"></b-icon-check2-circle>
          </p>
        </div>
        <div class="step-icon-border third-load-border-step2 mx-5 done">
          <b-icon-people-fill
            class="step-icon third-load-icon-step2"
            variant="success"
          ></b-icon-people-fill>
          <p class="step-caption text-success">
            {{ $t("section.sectionView.step2AssignStudents") }}
            <b-icon-check2-circle variant="success"></b-icon-check2-circle>
          </p>
        </div>
        <div
          class="step-icon-border third-load-border ml-5"
          :class="[{ done: saved }, { info: !saved }]"
        >
          <b-icon-person-check-fill
            class="step-icon third-load-icon"
            :style="[
              saved
                ? { color: 'white !important' }
                : { color: 'var(--secondary-color)' },
            ]"
          ></b-icon-person-check-fill>
          <p
            class="step-caption"
            :class="[{ 'text-success': saved }, { 'text-success': !saved }]"
          >
            {{ $t("section.sectionView.step3AssignTeachers")
            }}<b-icon-check2-circle
              :style="[saved ? { display: 'inline' } : { display: 'none' }]"
              variant="success"
            ></b-icon-check2-circle>
          </p>
        </div>
      </div>
      <span class="progress third-load done" :class="[{ fill: saved }]"></span>
      <div>
        <h5 class="ml-3">{{ $t("section.sectionView.teachers") }}</h5>
        <UserListSection
          v-if="step == 3"
          :key_component="'evaluators:'"
          :section_id="section.id"
          :users_ids="[].concat(section.professors)"
          :required_group_name="'PROFESORES'"
          :allows_crud="allows_crud"
          @changed="slotProfessorsChanged"
          :filter_by_student="false"
        ></UserListSection>
      </div>
    </div>
    <b-form-group
      v-if="step == 1"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="section"></ModificationDate>
    </b-form-group>
    <div class="mb-4" style="text-align: right">
      <b-button v-if="step != 1" class="mr-1" @click.prevent="prevStep">
        {{ $t("section.sectionView.previousStep") }}
      </b-button>
      <b-button v-if="step != total_steps" @click.prevent="nextStep">
        {{ $t("section.sectionView.nextStep") }}
      </b-button>
      <template v-if="step == 3 && allows_crud">
        <b-button
          v-if="!disabled_button_save"
          class="mr-1"
          @click="save"
          v-can="'teaching.add_section'"
          >{{ $t("reusable.common.save") }}</b-button
        >
        <b-button v-else class="mr-1" disabled v-can="'teaching.add_section'">{{
          $t("reusable.common.save")
        }}</b-button>
      </template>
    </div>
    <div class="row" v-if="allows_crud">
      <div
        v-if="show_delete_button && !isNaN(section.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          style="margin-top: -9%"
          size="sm"
          variant="danger"
          v-can="'teaching.delete_section'"
          @click="askForDelete"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
    </div>
    <div style="text-align: right" v-if="step == 3"></div>
    <b-modal
      v-if="matter && matter.matter != null"
      :id="`new-evaluation-list-modal`"
      hide-footer
      size="xl"
      :title="$t('section.sectionView.incompleteInfo')"
    >
      <InfoEvaluations
        :matter_id="matter.matter"
        :egress_profile_matter_id="matter.id"
        @close_modal="$bvModal.hide(`new-evaluation-list-modal`)"
      ></InfoEvaluations>
    </b-modal>
  </div>
</template>

<script>
import { generateUniqueId, toast, showLoadingAlert } from "@/utils/utils";
import * as names from "@/store/names";
import { mapGetters, mapMutations } from "vuex";
import { validationMixin } from "vuelidate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  required,
  // minValue,
  // maxValue,
  // numeric,
} from "vuelidate/lib/validators";

export default {
  name: "SectionForm",
  mixins: [validationMixin],
  components: {
    vSelect,
    UserListSection: () =>
      import("@/components/teaching/Scheduler/UserListSection"),
    InfoEvaluations: () =>
      import("@/components/new-evaluations/Evaluation/InfoEvaluations.vue"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    Section: {
      type: Object,
    },
    egress_profile_id: {},
    selected_matter_id: {},
    period_id: {
      type: Number,
    },
    shift_id: {
      type: Number,
    },
    campus_id: {
      type: Number,
    },
    selected_level: {
      type: [Number, null],
      default: null,
    },
    period_type: {
      type: Number,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    show_delete_button: {
      type: Boolean,
      default: true,
    },
    edit_matter: {
      type: Boolean,
      default: true,
    },
    edit_level: {
      type: Boolean,
      default: true,
    },
    edit_period: {
      type: Boolean,
      default: true,
    },
    edit_shift: {
      type: Boolean,
      default: true,
    },
    edit_campus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      step: 1,
      total_steps: 3,
      saved: false,
      matters_evaluations: [],
      disabled_button_save: false,
      period_type_id: this.Section ? null : this.period_type,
      section: {
        id: this.Section ? this.Section.id : generateUniqueId(),
        name: this.Section ? this.Section.name : "",
        color: this.Section ? this.Section.color : "#000000",
        attention_hours: this.Section ? this.Section.attention_hours : "",
        coexistence_rules: this.Section ? this.Section.coexistence_rules : "",
        // TODO: Preguntar si se mantiene fuera el plan_level de Section.
        // plan_level: this.Section ? this.Section.plan_level : 1,
        egress_profile_matter: this.Section
          ? this.Section.egress_profile_matter
          : null,
        matter: this.Section ? this.Section.matter : this.selected_matter_id,
        period: this.Section ? this.Section.period : this.period_id,
        shift: this.Section ? this.Section.shift : this.shift_id,
        campus: this.Section ? this.Section.campus : this.campus_id,
        students: this.Section ? this.Section.students : [],
        professors: this.Section ? this.Section.professors : [],
        sessions: this.Section ? this.Section.sessions : [],
        session_dates: this.Section ? this.Section.session_dates : [],
        updated_by: this.Section ? this.Section.updated_by : null,
        update_date: this.Section ? this.Section.update_date : null,
      },
    };
  },
  validations() {
    return {
      section: {
        name: {
          required,
          isUnique() {
            if (
              this.sections.some(
                (x) =>
                  x.id != this.section.id &&
                  this.$equals(x.name, this.section.name) &&
                  x.period === this.section.period &&
                  x.shift === this.section.shift &&
                  x.egress_profile_matter ==
                    this.section.egress_profile_matter &&
                  x.matter === this.section.matter &&
                  x.campus === this.section.campus
              )
            )
              return false;
            else return true;
          },
        },
        color: {},
        // plan_level: {
        //   required,
        //   numeric,
        //   minValue: minValue(1),
        //   maxValue: maxValue(18),
        // },
        matter: {
          valid(value) {
            if (!this.egressProfile) {
              if (value) return true;
              else return false;
            } else return true;
          },
        },
        egress_profile_matter: {
          valid(value) {
            if (this.egressProfile) {
              if (value != null && this.matter && this.matter.matter != null) {
                if (!this.theTestsHaveSomeErrors && isNaN(this.section.id))
                  return true;
                else if (!isNaN(this.section.id)) return true;
                else return false;
              } else return false;
            }
            return true;
          },
          // validMatter(value) {
          //   const matter = this.egress_profiles_matters.find(
          //     (x) => x.id == value
          //   );
          //   if (matter) {
          //     if (matter.is_closed) return true;
          //     else return false;
          //   } else return false;
          // },
        },
        period: { required },
        shift: { required },
        campus: { required },
        students: {},
        professors: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      matters: names.MATTERS,
      sections: names.SECTIONS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      periods: names.PERIODS,
      shifts: names.SHIFTS,
      campuses: names.CAMPUSES,
      regimes: names.REGIMES,
      user: "getUser",
      institution: "getInstitution",
      evaluations: names.NEW_EVALUATIONS,
      tests: names.NEW_TESTS,
      evaluationCriterias: names.EVALUATION_CRITERIAS,
      studyUnits: names.STUDY_UNITS,
    }),
    egressProfile() {
      if (!this.egress_profile_id) return null;
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    levels() {
      let list = [];
      if (!this.egressProfile) {
        for (let i = 1; i <= this.institution.max_semester_amount; i++) {
          list.push(i);
        }
        return list;
      } else {
        for (
          let index = 1;
          index <= this.egressProfile.semester_amount;
          index++
        ) {
          list.push(index);
        }
        return list;
      }
    },
    matterList() {
      let matterList = [];
      if (!this.egress_profile_id) return matterList;
      let list = this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
      if (this.selected_level != null)
        list = list.filter(
          (x) =>
            x.plan_level == this.selected_level ||
            this.section.egress_profile_matter
        );
      if (list.length > 0) {
        matterList = list.map((x) => {
          const matter = this.matters.find((matter) => matter.id == x.matter);
          if (matter)
            return {
              ...x,
              name: matter.name,
              label:
                matter.code +
                (this.institution &&
                this.institution.use_epm_code &&
                x.code &&
                x.code !== matter.code
                  ? " - " + x.code
                  : "") +
                " - " +
                matter.name,
            };
        });
      }
      return matterList;
    },
    sortMatters() {
      return this.matters
        .map((x) => ({ ...x, label: x.code + " - " + x.name }))
        .sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        });
    },
    periodList() {
      let periods_list = this.periods.map((period) => {
        let start_date = period.start_date;
        let end_date = period.end_date;
        if (start_date)
          start_date = this.$moment(start_date).format("DD/MM/YYYY");
        if (end_date) end_date = this.$moment(end_date).format("DD/MM/YYYY");
        return {
          ...period,
          label: `${period.name} De: ${start_date} al ${end_date}`,
        };
      });
      if (!this.period_type_id) return periods_list;
      return periods_list
        .filter((x) => x.period_type == this.period_type_id)
        .sort(function (a, b) {
          if (a.start_date < b.start_date) return 1;
          if (a.start_date > b.start_date) return -1;
        });
    },
    filteredCampuses() {
      if (!this.egressProfile)
        return [...this.campuses].sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      let list = [];
      this.egressProfile.campuses.forEach((campus_id) => {
        const instance = this.campuses.find((x) => x.id == campus_id);
        if (instance) list.push(instance);
      });
      return list.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    matter() {
      if (this.egressProfile && this.section.egress_profile_matter != null)
        return this.matterList.find(
          (x) => x.id == this.section.egress_profile_matter
        );
      return null;
    },
    filterEvaluationsByMatter() {
      // scope==3 para base_matter y para duoc aunque sea del egressProfile la sección.
      if (this.matter)
        return this.evaluations.filter(
          (x) => x.scope == 3 && x.scope_id == this.matter.matter
        );
      return [];
    },
    filterTestsByMatter() {
      const evaluations_ids = this.filterEvaluationsByMatter.map((x) => x.id);
      return this.tests.filter((x) => evaluations_ids.includes(x.evaluation));
    },
    theTestsHaveSomeErrors() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        if (
          this.filterTestsByMatter.some(
            (x) =>
              x.is_valid[0] == false ||
              (x.is_valid == true && x.manual_is_valid === false)
          ) ||
          this.filterTestsByMatter.length == 0 ||
          this.excludeECMicro.length > 0
        )
          return true;
      }
      return false;
    },
    excludeECMicro() {
      const evaluation_criterio_micro_ids = [
        ...new Set(
          this.matters_evaluations
            .map((x) => x.evaluation_criterias_micro)
            .flat()
        ),
      ];
      return this.ECMicroFilterByStudyUnit.filter(
        (x) => !evaluation_criterio_micro_ids.includes(x.id)
      );
    },
    ECMicroFilterByStudyUnit() {
      const study_unit_ids = this.studyUnitsFilterByMatter.map((x) => x.id);
      return this.evaluationCriterias
        .filter((x) => study_unit_ids.includes(x.study_unit))
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
    studyUnitsFilterByMatter() {
      return this.studyUnits
        .filter((x) => x.matter == this.matter.matter)
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
  },
  methods: {
    ...mapMutations([
      "setUserSectionProfessor",
      "UpdateUserSectionProfessor",
      "DeleteUserSectionProfessor",
    ]),
    validateState(name) {
      const { $dirty, $error } = this.$v.section[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.section.$touch();
      if (this.$v.section.$anyError) {
        return;
      }
      this.disabled_button_save = true;
      // if (this.step == 3 && this.section.professors.length == 0) {
      //   return this.$swal(
      //     "No se han ingresado profesores",
      //     "Por favor, asegúrese de asignar profesores a la sección antes de guardar.",
      //     "warning"
      //   );
      // }
      if (isNaN(this.section.id)) this.create();
      else this.update();
      this.saved = true;
    },
    create() {
      showLoadingAlert(
        this.$t("section.sectionView.creating", {
          entity: this.$getVisibleNames("teaching.section", false, "Sección"),
        }),
        this.$t("section.sectionView.pleaseWaitWhileCreating")
      );
      this.$store
        .dispatch(names.POST_SECTION, this.section)
        .then((response) => {
          if (this.section.professors.find((x) => x == this.user.id)) {
            let payload = { user_id: this.user.id, section: response };
            this.setUserSectionProfessor(payload);
          }
          this.$restful
            .Get(
              `/teaching/fill_evaluation_users_default/?section=${response.id}`
            )
            .then(() => {
              this.$emit("created", response);
              this.$swal.close();
              this.disabled_button_save = false;
            })
            .catch(() => {
              this.$emit("created", response);
              this.$swal.close();
              this.disabled_button_save = false;
            });
          toast(
            this.$t("section.sectionView.entityCreated", {
              entity: this.$getVisibleNames(
                "teaching.section",
                false,
                "Sección"
              ),
            })
          );
        })
        .catch(() => {
          this.$emit("created");
          this.$swal.close();
          this.disabled_button_save = false;
        });
    },
    update() {
      this.$store
        .dispatch(names.UPDATE_SECTION, this.section)
        .then((response) => {
          let payload = { user_id: this.user.id, section: response };
          this.UpdateUserSectionProfessor(payload);
          this.disabled_button_save = false;
          this.$emit("updated", response);
          toast(
            this.$t("section.sectionView.entityModified", {
              entity: this.$getVisibleNames(
                "teaching.section",
                false,
                "Sección"
              ),
            })
          );
        });
    },
    askForDelete() {
      this.$swal({
        title: this.$t("section.sectionView.confirmDeleteSection"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) this.delete();
      });
    },
    delete() {
      this.$store.dispatch(names.DELETE_SECTION, this.section.id).then(() => {
        this.$emit("deleted", this.section);
        let payload = { user_id: this.user.id, section: this.section };
        this.DeleteUserSectionProfessor(payload);
        toast(
          this.$t("section.sectionView.entityDeleted", {
            entity: this.$getVisibleNames("teaching.section", false, "Sección"),
          })
        );
      });
    },

    slotStudentsChanged(students) {
      this.section.students = [];
      students.forEach((user) => {
        const index = this.section.students.findIndex((x) => x == user.id);
        if (index == -1) this.section.students.push(user.id);
      });
    },
    slotProfessorsChanged(professors) {
      this.section.professors = [];
      professors.forEach((user) => {
        const index = this.section.professors.findIndex((x) => x == user.id);
        if (index == -1) this.section.professors.push(user.id);
      });
    },
    prevStep() {
      return this.step--;
    },
    nextStep() {
      if (this.allows_crud) {
        this.$v.section.$touch();
        if (this.$v.section.$anyError) {
          return;
        }
      }
      // if (this.step == 2 && this.section.students.length == 0) {
      //   return this.$swal(
      //     "No se han ingresado estudiantes",
      //     "Por favor, asegúrese de asignar estudiantes a la sección antes de continuar.",
      //     "warning"
      //   );
      // }
      return this.step++;
    },
    fetchInitEvaluations() {
      if (
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        // scoped_id:3 para base_matter
        if (this.matter)
          this.$store
            .dispatch(names.FETCH_NEW_EVALUATIONS, {
              scoped_id: 3,
              scoped_object_id: this.matter.matter,
            })
            .then((evaluations) => {
              this.$store.dispatch(names.FETCH_NEW_TESTS, {
                evaluations_ids: evaluations.map((x) => x.id),
              });
            });
      }
    },
    fetchECM() {
      if (this.matter) {
        this.$store.dispatch(names.FETCH_STUDY_UNITS, this.matter.matter);
        this.$store.dispatch(names.FETCH_EVALUATION_CRITERIAS, {
          matter_id: this.matter.matter,
        });
      }
    },
    changeEgressProfileMatter(value) {
      if (
        value != null &&
        this.egressProfile &&
        this.institution &&
        this.institution.internal_use_id == "duoc.cl" &&
        this.institution.kl_assessment
      ) {
        this.fetchInitEvaluations();
        this.fetchECM();
        this.fetchMattersEvaluation();
      }
    },
    fetchMattersEvaluation() {
      if (this.matter && this.matter.matter)
        this.$restful
          .GetAll(`/teaching/matter-evaluation/?matter=${this.matter.matter}`)
          .then((response) => {
            this.matters_evaluations = response.sort(function (a, b) {
              if (a.order > b.order) return 1;
              if (a.order < b.order) return -1;
              return 0;
            });
          });
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_ROLES);
    if (!isNaN(this.section.id)) {
      const period = this.periods.find((x) => x.id == this.section.period);
      if (period) this.period_type_id = period.period_type;
    }
    this.saved = false;
    this.$store.dispatch(names.FETCH_SHIFTS);
    if (this.egress_profile_id) {
      this.$store.dispatch(names.FETCH_MATTERS, {
        egress_profile_id: this.egress_profile_id,
      });
      this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
        egress_profile_id: this.egress_profile_id,
      });
    }
  },
};
</script>

<style scoped>
/* .v-select.diable-search >>> .vs__search { */
/* display: none; */
/* } */
p {
  margin-bottom: 0px !important;
  margin-top: 9px !important;
}
.div-invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
.group {
  width: 100%;
}
.hidden-step {
  display: none;
}
.is-shown {
  display: block;
}
.step-grid {
  display: flex;
  justify-content: center;
  margin-bottom: 10% !important;
}
.step-icon-border {
  width: 50px;
  height: 50px;
  border: 3px solid var(--secondary-color);
  border-radius: 50%;
  padding: 11px 1px 1px 12px;
  z-index: 30;
  background: #fff;
}
.first-load-border {
  background: white;
  border: 3px solid #28a745;
}
.second-load-border {
  border: 3px solid #28a745;
  background: white;
}
.third-load-border {
  background: white;
}
.second-load-border-step1 {
  background: #28a745;
}
.third-load-border-step1 {
  background: #28a745;
}
.third-load-border-step2 {
  background: #28a745;
}
.first-load-icon {
  color: var(--secondary-color);
}
.second-load-icon {
  color: var(--secondary-color);
}
.third-load-icon {
  color: var(--secondary-color);
}
.second-load-icon-step1 {
  color: white !important;
}
.third-load-icon-step1 {
  color: white !important;
}
.third-load-icon-step2 {
  color: white !important;
}
.step-icon {
  font-size: 22px;
}
.step-caption {
  width: 170px;
  text-align: center;
  margin-top: 1.3em;
  transform: translateX(-42%);
}
.progress {
  border: 1px solid var(--secondary-color);
  height: 10px;
  margin-top: -12.9%;
  margin-bottom: 5%;
}
.first-load {
  border: 3px solid #28a745;
  background: #28a745;
  width: 35%;
  margin-right: 20%;
}
.second-load {
  border: 3px solid #28a745;
  background: #28a745;
  width: 50%;
  margin-right: 20%;
}
.third-load {
  border: 3px solid #28a745;
  background: #28a745;
  width: 65%;
  margin-right: 20%;
}
.fill {
  width: 100%;
}
.container-group {
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  flex-wrap: wrap;
  margin-top: 7%;
}
.done {
  border: 3px solid #28a745 !important;
  background: #28a745;
  transition: 0.4s;
}
.link-modal-evaluations {
  text-decoration: underline; /* Aplica subrayado */
  cursor: pointer; /* Cambia el puntero a una mano */
  color: #0000ee; /* Color azul típico de los enlaces */
}
.link-modal-evaluations:hover {
  font-weight: bold; /* Aplica negrita al hacer hover */
  color: #551a8b; /* Cambia el color al hacer hover, a un morado oscuro similar al de los enlaces visitados */
}
@media (max-width: 1200px) {
  .progress {
    margin-top: -16%;
    margin-bottom: 7%;
  }
  .first-load {
    width: 30%;
  }
  .third-load {
    width: 70%;
  }
}
@media (max-width: 991px) {
  .progress {
    margin-top: -20%;
    margin-bottom: 19%;
  }
  .step-icon-border {
    margin-right: 1% !important;
  }
  .step-caption {
    width: 190px;
    padding: 0 10px;
  }
  .first-load {
    width: 25%;
  }
}
</style>